document.addEventListener('DOMContentLoaded', () => {
  // E3 uses article images; product handles are only for the links below the slider.
  const productContainers = document.querySelectorAll('.ci-custom-product:not(.ci-block--e3)');
  productContainers.forEach((container) => {
    const handles = container.dataset.handle;
    if (!handles) return;

    if (handles.includes(',')) {
      const handlesAll = handles.split(',');

      const titleWrapper = container.querySelector('.title-wrapper');
      const swiperWrapper = container.querySelector('.swiper-wrapper');
      const productWrapper = container.querySelector('.product-wrapper');

      if (titleWrapper) titleWrapper.innerHTML = '';
      if (swiperWrapper) swiperWrapper.innerHTML = '';
      if (productWrapper) productWrapper.innerHTML = '';

      handlesAll.forEach(() => {
        if (titleWrapper) {
          titleWrapper.insertAdjacentHTML(
            'beforeend',
            '<a data-product-url><p data-product-title></p></a>',
          );
        }
        if (swiperWrapper) {
          swiperWrapper.insertAdjacentHTML(
            'beforeend',
            '<div class="swiper-slide ci-slider-item"><a data-product-url><img data-product-image></a></div>',
          );
        }
        if (productWrapper) {
          productWrapper.insertAdjacentHTML(
            'beforeend',
            '<div class="product-item"><a data-product-url><img data-product-image><p data-product-title></p></a><p data-product-price></p></div>',
          );
        }
      });

      const productTitle = container.querySelectorAll('[data-product-title]');
      const productImage = container.querySelectorAll('[data-product-image]');
      const productPrice = container.querySelectorAll('[data-product-price]');
      const titleLinks = container.querySelectorAll('.left-contents [data-product-url]');
      const imageLinks = container.querySelectorAll('.swiper-slide [data-product-url]');
      const productUrl = container.querySelectorAll('[data-product-url]');

      handlesAll.forEach((handle, index) => {
        fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
          .then((response) => {
            if (!response.ok) throw new Error('商品が見つからないか非公開です');
            return response.json();
          })
          .then((product) => {
            if (!product.images || product.images.length === 0) {
              throw new Error('画像が未設定です');
            }
            if (titleLinks[index]) titleLinks[index].href = product.url;
            if (imageLinks[index]) imageLinks[index].href = product.url;
            if (productUrl[index]) productUrl[index].href = product.url;
            if (productTitle[index]) productTitle[index].textContent = product.title;
            if (productPrice[index]) productPrice[index].textContent = '￥' + product.price / 100;
            if (productImage[index] && product.images && product.images.length > 0) {
              productImage[index].src = product.images[0];
              productImage[index].alt = product.title;
            }
          })
          .catch((error) => {
            if (titleLinks[index]) titleLinks[index].style.display = 'none';
            if (imageLinks[index]) {
              imageLinks[index].removeAttribute('href');
              imageLinks[index].innerHTML = `
                                <div style="background: #f4f4f4; width: 100%; aspect-ratio: 1/1; display: flex; align-items: center; justify-content: center; color: #999; font-size: 14px;">
                                    準備中
                                </div>
                            `;
            }
          });
      });
    } else {
      const brand = container.querySelector('[data-brand]');
      const productTitle = container.querySelector('[data-product-title]');
      const productPrice = container.querySelector('[data-product-price]');
      const productImage = container.querySelector('[data-product-image]');
      const productUrl = container.querySelectorAll('[data-product-url]');

      fetch(window.Shopify.routes.root + 'products/' + handles + '.js')
        .then((response) => {
          if (!response.ok) throw new Error('商品が見つからないか非公開です');
          return response.json();
        })
        .then((product) => {
          if (brand) brand.textContent = product.vendor;
          if (productTitle) productTitle.textContent = product.title;
          if (productPrice) productPrice.textContent = '￥' + product.price / 100;
          if (productImage && product.images && product.images.length > 0) {
            productImage.src = product.images[0];
            productImage.alt = product.title;
          }
          if (productUrl) {
            for (const url of productUrl) {
              url.href = product.url;
            }
          }
        })
        .catch((error) => {
          if (brand) brand.style.display = 'none';
          if (productTitle) productTitle.style.display = 'none';
          if (productPrice) productPrice.style.display = 'none';
          if (productImage) {
            productImage.removeAttribute('href');
            productImage.innerHTML = `
                            <div style="background: #f4f4f4; width: 100%; aspect-ratio: 1/1; display: flex; align-items: center; justify-content: center; color: #999; font-size: 14px;">
                                準備中
                            </div>
                        `;
          }
        });
    }
  });

  const sliders = document.querySelectorAll('#ci-article-template .ci-slider');
  sliders.forEach(function (slider) {
    const myPagination = slider.querySelector('.swiper-pagination');
    const myNextBtn = slider.querySelector('.swiper-button-next');
    const myPrevBtn = slider.querySelector('.swiper-button-prev');

    new Swiper(slider, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      loop: true,
      observer: true,
      observeParents: true,

      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },

      pagination: {
        el: myPagination,
        clickable: true,
      },
      navigation: {
        nextEl: myNextBtn,
        prevEl: myPrevBtn,
      },
    });
  });
});
// ③ Hパーツ：商品リンク自動生成
document.querySelectorAll('.ci-block--h.ci-custom-product').forEach(function (block) {
  var handles = (block.dataset.handle || '')
    .split(',')
    .map(function (h) {
      return h.trim();
    })
    .filter(Boolean);
  var linkList = block.querySelector('.ci-link-list');
  if (!linkList || !handles.length) return;
  handles.forEach(function (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var a = document.createElement('a');
        a.href = '/products/' + handle;
        a.textContent = product.title;
        linkList.appendChild(a);
      })
      .catch(function () {});
  });
});
// E3: keep article images in the slider and show them in a looping lightbox.
function initE3() {
  document.querySelectorAll('#ci-article-template .ci-block--e3').forEach((block) => {
    const slider = block.querySelector('.ci-slider--e3');
    const overlay = block.querySelector('.ci-lightbox-overlay');
    if (!slider || slider.dataset.ciE3Ready === 'true') return;
    slider.dataset.ciE3Ready = 'true';

    // The sample article repeats its final image. Show each image once.
    const seenSources = new Set();
    slider.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach((slide) => {
      const trigger = slide.querySelector('.ci-lightbox-trigger');
      const src = trigger?.getAttribute('href') || trigger?.querySelector('img')?.src;
      if (!src) return;
      if (seenSources.has(src)) {
        slide.remove();
      } else {
        seenSources.add(src);
      }
    });

    const entries = Array.from(slider.querySelectorAll('.ci-lightbox-trigger'))
      .map((trigger) => ({
        trigger,
        src: trigger.getAttribute('href') || trigger.querySelector('img')?.src,
        alt: trigger.querySelector('img')?.alt || '',
      }))
      .filter((entry) => entry.src);
    entries.forEach(({ trigger }, index) => {
      trigger.dataset.ciLightboxIndex = String(index);
    });

    new Swiper(slider, {
      loop: entries.length > 1,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    const image = overlay?.querySelector('.ci-lightbox-img');
    const closeButton = overlay?.querySelector('.ci-lightbox-close');
    if (!overlay || !image || !closeButton || !entries.length) return;

    const makeArrow = (direction, label, symbol) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `ci-lightbox-arrow ci-lightbox-${direction}`;
      button.setAttribute('aria-label', label);
      button.textContent = symbol;
      button.hidden = entries.length < 2;
      overlay.appendChild(button);
      return button;
    };
    const previousButton = makeArrow('prev', '前の画像', '‹');
    const nextButton = makeArrow('next', '次の画像', '›');

    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', '画像を拡大表示');
    overlay.setAttribute('aria-hidden', 'true');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', '拡大表示を閉じる');
    document.body.appendChild(overlay);

    let currentIndex = 0;
    let previousFocus = null;
    let touchStart = null;
    let lastSwipeAt = 0;
    const showImage = (index) => {
      currentIndex = (index + entries.length) % entries.length;
      image.src = entries[currentIndex].src;
      image.alt = entries[currentIndex].alt || `拡大画像 ${currentIndex + 1} / ${entries.length}`;
      overlay.dataset.ciLightboxIndex = String(currentIndex);
    };
    const close = () => {
      if (!overlay.classList.contains('is-active')) return;
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ci-lightbox-open');
      image.removeAttribute('src');
      touchStart = null;
      previousFocus?.focus({ preventScroll: true });
    };

    slider.addEventListener('click', (event) => {
      const trigger = event.target.closest('.ci-lightbox-trigger');
      if (!trigger || !slider.contains(trigger)) return;
      event.preventDefault();
      event.stopPropagation();
      previousFocus = trigger;
      showImage(Number(trigger.dataset.ciLightboxIndex));
      overlay.classList.add('is-active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ci-lightbox-open');
      closeButton.focus({ preventScroll: true });
    });

    previousButton.addEventListener('click', () => showImage(currentIndex - 1));
    nextButton.addEventListener('click', () => showImage(currentIndex + 1));
    closeButton.addEventListener('click', close);
    overlay.addEventListener('touchstart', (event) => {
      if (
        !overlay.classList.contains('is-active') ||
        entries.length < 2 ||
        event.touches.length !== 1 ||
        event.target.closest('button')
      ) {
        touchStart = null;
        return;
      }
      const touch = event.touches[0];
      touchStart = { id: touch.identifier, x: touch.clientX, y: touch.clientY };
    });
    overlay.addEventListener('touchmove', (event) => {
      if (event.touches.length > 1) touchStart = null;
    });
    overlay.addEventListener('touchend', (event) => {
      if (!touchStart) return;
      const touch = Array.from(event.changedTouches).find(
        (item) => item.identifier === touchStart.id,
      );
      if (!touch) return;
      const horizontal = touch.clientX - touchStart.x;
      const vertical = touch.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(horizontal) < 50 || Math.abs(horizontal) <= Math.abs(vertical) * 1.25) {
        return;
      }
      lastSwipeAt = Date.now();
      showImage(currentIndex + (horizontal < 0 ? 1 : -1));
    });
    overlay.addEventListener('touchcancel', () => {
      touchStart = null;
    });
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay && Date.now() - lastSwipeAt > 450) close();
    });
    document.addEventListener('keydown', (event) => {
      if (!overlay.classList.contains('is-active')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'ArrowLeft' && entries.length > 1) {
        event.preventDefault();
        showImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight' && entries.length > 1) {
        event.preventDefault();
        showImage(currentIndex + 1);
      } else if (event.key === 'Tab') {
        const controls = [closeButton, previousButton, nextButton].filter(
          (button) => !button.hidden,
        );
        const index = controls.indexOf(document.activeElement);
        if (event.shiftKey && index <= 0) {
          event.preventDefault();
          controls[controls.length - 1].focus();
        } else if (!event.shiftKey && index === controls.length - 1) {
          event.preventDefault();
          controls[0].focus();
        }
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initE3);
} else {
  initE3();
}

// Eパーツ(3)：商品リンク自動生成（複数対応・順序保持）
(function () {
  document.querySelectorAll('.ci-block--e3.ci-custom-product').forEach(function (block) {
    // 要望3：全角カンマ・前後スペースを正規化してパース
    var rawHandle = (block.dataset.handle || '').replace(/，/g, ',');
    var handles = rawHandle
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
    var linkList = block.querySelector('.ci-link-list--e3');
    if (!linkList || !handles.length) return;

    // 要望3：順序を保持するためプレースホルダーを先に作成
    var placeholders = handles.map(function () {
      var p = document.createElement('p');
      p.style.margin = '0';
      p.style.padding = '0';
      linkList.appendChild(p);
      return p;
    });

    handles.forEach(function (handle, index) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        })
        .then(function (product) {
          var p = placeholders[index];
          var a = document.createElement('a');
          a.href = '/products/' + handle;
          a.textContent = product.title;
          if (product.vendor) {
            var vendorText = document.createTextNode(product.vendor + ' - ');
            p.appendChild(vendorText);
          }
          p.appendChild(a);
        })
        .catch(function () {
          // fetchに失敗したプレースホルダーを削除
          if (placeholders[index] && placeholders[index].parentNode) {
            placeholders[index].parentNode.removeChild(placeholders[index]);
          }
        });
    });
  });
})();
// Dパーツ・Dパーツ(2)：商品リンク自動生成
(function () {
  document
    .querySelectorAll('.ci-block--d.ci-custom-product, .ci-block--d2.ci-custom-product')
    .forEach(function (block) {
      var handle = (block.dataset.handle || '').trim();
      if (!handle) return;

      // ci-link-list--d を動的に生成してbottom-contentsの先頭に挿入
      var bottomContents = block.querySelector('.bottom-contents');
      if (!bottomContents) return;

      var linkList = document.createElement('div');
      linkList.className = 'ci-link-list--d';
      bottomContents.insertBefore(linkList, bottomContents.firstChild);

      fetch('/products/' + handle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (product) {
          var p = document.createElement('p');
          var a = document.createElement('a');
          a.href = '/products/' + handle;
          a.textContent = product.title;
          if (product.vendor) {
            p.textContent = product.vendor + ' - ';
          }
          p.appendChild(a);
          linkList.appendChild(p);
        })
        .catch(function () {});
    });
})();
// Dパーツ(3)：商品リンク自動生成（複数ハンドル対応）
(function () {
  document.querySelectorAll('.ci-block--d3.ci-custom-product').forEach(function (block) {
    var handles = (block.dataset.handle || '')
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
    if (!handles.length) return;

    var bottomContents = block.querySelector('.bottom-contents');
    if (!bottomContents) return;

    var linkList = document.createElement('div');
    linkList.className = 'ci-link-list--d3';
    bottomContents.insertBefore(linkList, bottomContents.firstChild);

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (product) {
          var p = document.createElement('p');
          var a = document.createElement('a');
          a.href = '/products/' + handle;
          a.textContent = product.title;
          if (product.vendor) {
            p.textContent = product.vendor + ' - ';
          }
          p.appendChild(a);
          linkList.appendChild(p);
        })
        .catch(function () {});
    });
  });
})();
